import m from "../../geodata/es2015/canadaLow";
window.am4geodata_canadaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/canadaLow.js
// module id = null
// module chunks = 